/** Aide adhésion / portail / Black Dragon — BT-GSD-KARATE-MEMBERSHIP-PORTAL-001 (FR). */

function topic(key, screenLabel, purpose, actions, warning, nextStep) {
  return { key, screenLabel, purpose, actions, warning, nextStep };
}

export const helpTopicsMembershipFr = {
  "become-member": topic(
    "become-member",
    "Devenir membre",
    "Inscrire un adulte ou un mineur : identité, santé, consentements, puis paiement de démonstration.",
    [
      "Choisir Adulte ou Mineur.",
      "Compléter identité, contact d'urgence et parent si mineur.",
      "Remplir le formulaire santé, les consentements, puis payer en démonstration.",
    ],
    "Paiement de démonstration uniquement — aucune carte réelle. Formulaire santé temporaire en attendant le document officiel.",
    "Après activation, connectez-vous pour ouvrir Mon espace.",
  ),
  "public-calendar": topic(
    "public-calendar",
    "Calendrier général",
    "Voir uniquement les événements publics de l'organisation.",
    ["Parcourir, rechercher et trier les événements publics.", "Aucune donnée d'élève ou de santé n'est affichée."],
    "Les calendriers de dojo internes restent réservés aux membres actifs.",
    "Devenir membre pour voir le calendrier de votre dojo.",
  ),
  "public-black-dragon": topic(
    "public-black-dragon",
    "Black Dragon public",
    "Présentation publique de Black Dragon — adhésion privée distincte du statut membre.",
    ["Lire le contenu public.", "Devenir membre Shotokan AAMC avant toute invitation Black Dragon."],
    "Le contenu privé Black Dragon n'est jamais visible ici.",
    "Compléter une adhésion Shotokan puis demander ou attendre une invitation.",
  ),
  "member-adhesion": topic(
    "member-adhesion",
    "Mon adhésion",
    "Consulter le statut, le renouvellement, le paiement et vos informations santé autorisées.",
    ["Vérifier le statut actif et la date de fin.", "Relire vos informations personnelles et santé."],
    "Les données santé sont protégées — elles ne sont pas listées publiquement.",
    "Renouveler lorsque la période approche de la fin.",
  ),
  "member-calendar": topic(
    "member-calendar",
    "Mon calendrier",
    "Voir les événements de votre dojo et les événements généraux pertinents.",
    ["Rechercher et trier les événements.", "Comparer avec le calendrier public."],
    "Les événements internes des autres dojos ne sont pas exposés automatiquement.",
    "Ouvrir Aujourd'hui pour le prochain cours.",
  ),
  "member-exams": topic(
    "member-exams",
    "Mes examens",
    "Consulter l'historique d'examens et la progression autorisée, sans notes privées d'instructeur.",
    ["Voir le grade actuel et l'historique.", "Repérer un prochain examen s'il est prévu."],
    "Les notes privées Sensei restent masquées dans l'espace membre.",
    "Parler à votre Sensei pour les prochaines étapes.",
  ),
  "member-black-dragon": topic(
    "member-black-dragon",
    "Espace Black Dragon",
    "Demander, suivre une invitation et consulter le contenu selon la visibilité.",
    ["Vérifier que l'adhésion Shotokan est active.", "Soumettre une demande si l'option est ouverte.", "Lire uniquement le contenu autorisé."],
    "Sans adhésion Shotokan active, Black Dragon ne peut pas être activé.",
    "Un administrateur approuve ou refuse la demande.",
  ),
  "parent-membership": topic(
    "parent-membership",
    "Adhésion enfants",
    "Choisir un enfant pour voir calendrier, progression, adhésion et formulaires autorisés.",
    ["Sélectionner l'enfant.", "Consulter adhésion et santé autorisée.", "Un seul compte parent peut gérer plusieurs profils."],
    "Le parent ne reçoit aucun droit administratif automatique.",
    "Compléter un renouvellement depuis la fiche de l'enfant.",
  ),
  "admin-membership": topic(
    "admin-membership",
    "Cockpit d'adhésion",
    "Suivre inscriptions en cours, paiements, santé, membres actifs, renouvellements et Black Dragon.",
    [
      "Filtrer par étape manquante.",
      "Ouvrir la fiche 360.",
      "Inviter ou approuver Black Dragon.",
      "Ajuster le montant de cotisation annuelle.",
    ],
    "Ne jamais exporter la santé dans un fichier général. Le Sensei ne voit pas la santé par défaut (politique temporaire).",
    "Traiter d'abord les paiements en attente et les formulaires santé incomplets.",
  ),
  "admin-black-dragon-membership": topic(
    "admin-black-dragon-membership",
    "Adhésions Black Dragon",
    "Gérer demandes et invitations Black Dragon avec historique de décision.",
    ["Approuver seulement si l'adhésion Shotokan est active.", "Refuser avec trace de la personne et de la date."],
    "Black Dragon ne remplace jamais le statut membre.",
    "Retour au cockpit d'adhésion pour la fiche 360.",
  ),
  "admin-official-members": topic(
    "admin-official-members",
    "Membres officiels CKA",
    "Consulter les étudiants importés par instructeur, dojo, nom, grade et statut, puis ouvrir la fiche 360.",
    [
      "Filtrer par instructeur, dojo, grade, statut ou adulte/mineur.",
      "Ouvrir Gilles, Marie-Ève, Richard Pik ou un étudiant pour vérifier les relations.",
      "Réappliquer l'import : aucun doublon ne doit être créé.",
    ],
    "Les informations médicales restent hors de cette liste. Aucun compte de connexion n'est créé automatiquement.",
    "Traiter les fiches marquées À vérifier, puis ouvrir la fiche 360.",
  ),
};
